<video #player class="video-js vjs-fluid vjs-big-play-centered" *ngIf="(mediaRecord$ | async)?.hasPreview(); else placeholder"></video>

<ng-template #placeholder>
    <sh-media-placeholder [spinning]="spinning$ | async" class="placeholder" [message]="placeholderMessage" [showMessage]="true"></sh-media-placeholder>
</ng-template>
